import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class GeofenceZonesAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // GET //
  getManyError() {
    return this.bringozToastService.error({body: 'GEOFENCE_ZONE_GET_MANY_ERROR'});
  }

  // CREATE //
  createSuccess() {
    return this.bringozToastService.success({body: 'GEOFENCE_ZONE_CREATE_SUCCESS'});
  }

  createError() {
    return this.bringozToastService.error({
      body: 'GEOFENCE_ZONE_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    });
  }

  // UPDATE //
  updateSuccess() {
    return this.bringozToastService.success({body: 'GEOFENCE_ZONE_UPDATE_SUCCESS'});
  }

  updateError() {
    return this.bringozToastService.error({
      body: 'GEOFENCE_ZONE_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    });
  }

  // REMOVE //
  removeSuccess() {
    return this.bringozToastService.success({body: 'GEOFENCE_ZONE_REMOVE_SUCCESS'});
  }

  removeError() {
    return this.bringozToastService.error({
      body: 'GEOFENCE_ZONE_REMOVE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    });
  }
}

angular
  .module('bringoz.admin.service-areas')
  .service('geofenceZonesAlerts', GeofenceZonesAlerts);
